import { alpha, styled } from '@mui/material/styles'
import { bgGradient } from '../../utils/cssStyles'

export const StyledRoot = styled('main')(({ theme }) => ({
  height: 'auto',
  minHeight: '100%',
  position: 'relative',
  [theme.breakpoints.up('lg')]: {
    display: 'flex',
    flexDirection: 'row',
  },
}))

export const StyledSection = styled('div')(({ theme }) => ({
  display: 'none',
  position: 'relative',
  [theme.breakpoints.up('lg')]: {
    flexGrow: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
}))

export const StyledSectionBg = styled('div')(({ theme }) => ({
  ...bgGradient({
    color: alpha(theme.palette.background.default, theme.palette.mode === 'light' ? 0.9 : 0.94),
    imgUrl: '/assets/background/overlay_2.jpg',
  }),
  top: 0,
  left: 0,
  zIndex: -1,
  width: '100%',
  height: '100%',
  position: 'absolute',
  transform: 'scaleX(-1)',
}))

export const StyledContent = styled('div')(({ theme }) => ({
  minHeight: '100vh',
  maxWidth: 480,
  width: '100%',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  padding: theme.spacing(0, 4, 4, 4),
  [theme.breakpoints.up('lg')]: {
    maxWidth: 720,
    width: '50%',
    flexShrink: 0,
    padding: theme.spacing(0, 12, 0, 12),
  },
}))
